module.exports = __webpack_public_path__ + "static/media/monsters.9ce26f48.gif";